<template>
    <div class="location" is-link @click="verifyAgain">
       <p>{{ title }}</p>
        <div class="cell-value">
          <input type="text" v-model="address" :placeholder="placeholder" />
          <div @click="getAddress">
            <img
              class="location-icon"
              src="@/assets/images/icon_dwx.png"
              alt=""
            />
            <!-- <span style="color:var(--base)">定位</span> -->
          </div>
        </div>
    </div>
</template>

<script>
// import eventBus from "@/components/cell/GetAddress2/eventBus";
import wx, { verification } from "@/utils/wxPermissionValidation";

export default {
  name: "GetAddress",
  model: {
    prop: "address",
    event: "change",
  },
  props: {
    title: {
      type: String,
      default: "门店地址",
    },
    placeholder: {
      type: String,
      default: "请点击选择位置信息",
    },
    address: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      value: "",
      isShowSelectAddress: false,
      latitude: "",
      longitude: "",
      isVerified: false,
    };
  },
  watch: {
    value(value) {
      this.$emit("change", value);
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isShowSelectAddress) {
      this.isShowSelectAddress = false;
    } else {
      next();
    }
  },
  mounted() {
    //  eventBus.$on('selectedAddress', data=>{
    //     let {address}=data
    //     this.$emit('change', address)
    //     this.value=address
    //     console.log(data)
    //   });
  },
  methods: {
    getAddress() {
      if (process.env.NODE_ENV === "production") {
        verification(["openLocation"]).then(() => {
          this.isVerified = true;
          if (!this.latitude && !this.longitude) {
            wx.getLocation({
              type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
              success: (res) => {
                this.latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                this.longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                // var speed = res.speed; // 速度，以米/每秒计
                // var accuracy = res.accuracy; // 位置精度
                this.$router.push({
                  path: `/SelectliantAddress/${this.longitude}/${this.latitude}`,
                });
              },
            });
          } else {
            this.$router.push({
              path: `/SelectliantAddress/${this.longitude}/${this.latitude}`,
            });
          }
        });
      } else {
        this.$router.push({
          path: `/SelectliantAddress/${104.062035}/${30.596188}`,
        });
      }
    },
    verifyAgain() {
      if (!this.isVerified) {
        this.getAddress();
      }
    },
  },
};
</script>

<style scoped lang="less">
.cell-value {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  white-space: nowrap;
}

.location {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.26667rem 0.32rem;
  padding-bottom: 0;
  width: 100%;
  
  >p{
    font-size: 0.37333rem;
    line-height: 1.33333rem;
    color: #666;
    width: 6em;
  }
  .van-cell__value {
    flex: 4;
  }

  input {
    font-size: 28px !important;
    text-align: right;
    background: transparent;
    // width: 16em;
    flex: 1;
  }

  .location-icon {
    width: 28px;
    height: 37px;
    position: relative;
  }
}
</style>
